import { forwardRef } from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { WrappedComponent } from './WrappedComponent';
import { mergeSxStyle } from '../common/mergeSxStyle';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const styledContentContainer = _ref => {
  let {
    size
  } = _ref;
  return {
    maxWidth: '200px',
    width: size === 'large' || size === 'lg' ? '200px' : 'auto',
    ...(size === 'small' || size === 'sm' ? {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    } : {})
  };
};
const offsetMap = {
  left: 0,
  right: 0,
  top: 0,
  'top-start': 0,
  'top-end': 0,
  bottom: 0,
  'bottom-start': 0,
  'bottom-end': 0
};
/**
 * Messages that appear on hover and explain elements on the screen
 * @param className
 * @param position
 * @param children
 * @param toolTipContent
 * @param id
 * @constructor
 */
export const Tooltip = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    position = 'bottom',
    children,
    toolTipContent,
    id,
    size,
    sx,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const toolTipStyle = {
    backgroundColor: theme.tokens.ComponentTooltipBgColor,
    color: theme.tokens.ComponentTooltipColor,
    fontSize: size === 'large' || size === 'lg' ? theme.tokens.ComponentTooltipFontSizeLarge : theme.tokens.ComponentTooltipFontSizeSmall,
    lineHeight: size === 'large' || size === 'lg' ? theme.tokens.ComponentTooltipFontLineHeightLarge : theme.tokens.ComponentTooltipFontLineHeightSmall,
    fontWeight: 400,
    padding: size === 'large' || size === 'lg' ? '8px' : '6px 8px',
    '& .MuiTooltip-arrow': {
      color: theme.tokens.ComponentTooltipBgColor
    }
  };
  const toolTipSx = mergeSxStyle(toolTipStyle, sx);
  const effectiveId = id || 'interstate-tooltip';
  return /*#__PURE__*/_jsx(MuiTooltip, {
    PopperProps: {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [offsetMap[position], -4]
        }
      }]
    },
    classes: {
      popper: className
    },
    title: /*#__PURE__*/_jsx(Box, {
      sx: styledContentContainer({
        size
      }),
      id: `tooltip-title-container-"${effectiveId}`,
      "data-testid": rest['data-testid'],
      children: toolTipContent
    }),
    arrow: true,
    id: effectiveId,
    placement: position,
    className: className,
    componentsProps: {
      tooltip: {
        sx: toolTipSx
      }
    },
    ref: ref,
    children: /*#__PURE__*/_jsx(WrappedComponent, {
      children: children
    })
  });
});
Tooltip.displayName = 'Tooltip';